var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquidtele(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 77,
    viewBox: "0 0 108 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.522 69.6056C37.889 69.6056 38.3369 68.6123 37.4285 66.1039L29.6865 40.626L89.2818 5.26978",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5225 69.6057C42.5541 69.6057 43.4517 68.6774 44.5858 67.574L55.4213 57.0383L41.9058 48.8882",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9038 48.8899L74.6541 73.0856C78.3923 75.1479 81.0886 74.0806 82.0204 69.6164L95.3517 6.7958C96.717 1.32387 93.2659 -1.15926 89.6901 0.464259L11.4091 30.6484C6.06535 32.792 6.09785 35.7735 10.4357 37.1009L30.5247 43.371L77.0307 14.0303C79.2267 12.6993 81.2421 13.4145 79.5878 14.8827L41.9038 48.8899Z",
    fill: "#FCFDFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 77,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquidtele);
export default __webpack_public_path__ + "static/media/squidtele.2b59aca9c0633097ca6a1b04cfbdc859.svg";
export { ForwardRef as ReactComponent };